<template>
    <div v-loading="loading">
        <el-card>
            <div slot="header">
                <el-date-picker
                        v-model="date"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"/>
                <el-button style="margin-left: 15px" type="primary" @click="getDetail">查询</el-button>
            </div>
            <div style="line-height: 40px">
                <p v-text="`新增注册玩家数量：${newUserNum}`"></p>
                <p v-text="`新增注册玩家完成首充数量：${finishNum}`"></p>
            </div>
        </el-card>
    </div>
</template>
<script>
    import {mapActions} from 'vuex';

    export default {
        data() {
            return {
                date: null,
                loading: false,
                finishNum: 0,
                newUserNum: 0
            }
        },
        methods: {
            ...mapActions('user', ['getNewUserData']),
            getDetail() {
                if (!this.date) {
                    this.$message.error('请选择时间');
                    return
                }
                this.loading = true;
                this.getNewUserData({
                    startTime: this.date[0],
                    endTime: this.date[1]
                }).then(res => {
                    this.loading = false;
                    this.finishNum = res.data.finishNum;
                    this.newUserNum = res.data.newUserNum;
                })
            }
        }
    }
</script>